import { gql } from "@apollo/client";

const SYNC_WOO_COMMERCE_PRODUCTS = gql`
  mutation {
    syncWooCommerceProducts {
      data
      status
      error
    }
  }
`;

export default SYNC_WOO_COMMERCE_PRODUCTS;
